import { APP_STORE_ID, PLAY_STORE_ID } from "./stores";

export const DOMAINS = {
  WEBSITE: "https://www.entspannungshelden.de",
  PREVIEW_WEBSITE: "https://preview.entspannungshelden.de",
  SUPPORT: "https://hilfe.entspannungshelden.de",
  CMS: "https://cms.entspannungshelden.de",
  CMS_DEV: "https://entspannungshelden-app-dev.web.app",
};

export const EXTERNAL_LINKS = {
  PLAY_STORE: `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}`,
  APP_STORE: `https://apps.apple.com/de/app/entspannungshelden-app/id${APP_STORE_ID}`,
  /** Apple subscription management (Settings → Apple ID → Subscriptions). */
  APP_STORE_SUBSCRIPTIONS: "https://apps.apple.com/account/subscriptions",
  /** Google Play subscription management. */
  GOOGLE_PLAY_SUBSCRIPTIONS: "https://play.google.com/store/account/subscriptions",
  /** Apple App Store refund process (Pfad B — Widerruf App-Abo). */
  APP_STORE_REFUND: "https://reportaproblem.apple.com",
  /** Google Play refund process (Pfad C — Widerruf App-Abo). */
  GOOGLE_PLAY_REFUND: "https://support.google.com/googleplay/answer/2479637",
  /** ablefy payer help — how to withdraw a purchase (German). */
  ABLEFY_WITHDRAWAL_HELP:
    "https://support.ablefy.io/payer/s/article/WiekannichmeinenKaufwiderrufen64a8035004d95?language=de",
  SPOTIFY: "https://open.spotify.com/show/0YLyHoKVt8R7UlR6qNM9Kv",
  APPLE_PODCAST: "https://podcasts.apple.com/de/podcast/entspannungshelden-meditation-entspannung/id1550796827",
  AMAZON_MUSIC:
    "https://music.amazon.de/podcasts/56a800e4-ff2c-48c8-b658-bd9c6786954d/entspannungshelden-meditation-entspannung",
  LETS_CAST_FEED_URL: "https://letscast.fm/podcasts/entspannungshelden-meditation-entspannung-02ceb1e0/feed",
};
